import axios from "axios";

export const minishopAPI = {
    baseUrl : process.env.REACT_APP_API_URL,
    baseUrl2 : process.env.REACT_APP_API2_URL,

    getMinishopInfo: function(miniShopName) {
        let _url = `${this.baseUrl}/front/v2/minishop/view/?mall_web_user=${miniShopName}`
        return axios.get(_url)
    },
    getMinishopLogo: function(idx_b_manager,type){
        let _url = `${this.baseUrl2}/mobile/v1/logo/${idx_b_manager}/`
        if (type !== undefined){
            _url = `${this.baseUrl2}/mobile/v1/logo/${idx_b_manager}/${type}`
        }
        return axios.get(_url)
    }
}



// WEBPACK FOOTER //
// ./src/common/api/minishop.js